import React from "react";

function FooterHome() {
  return (
    <div className="row footer">
      <div className="col">
        <div>
          Created with <i className="fas fa-heart"></i> by the{" "}
          <span>
            <a href="https://codepreneurs.brainster.co/">
              {" "}
              Brainster Code Academy
            </a>
          </span>{" "}
          students and{" "}
          <span>
            <a href="https://www.wearelaika.com/"> wearelaika.com</a>
          </span>
        </div>
      </div>
    </div>
  );
}

export default FooterHome;
